export default function getSortedFavoriteLists(lists) {
  if (!lists || !lists.length) {
    return [];
  }

  const defaultList = lists.find(list => list.isDefault) || [];
  const nonDefaultLists = lists.filter(list => !list.isDefault);
  return [].concat(defaultList, nonDefaultLists);
}
